import { ethers } from "ethers";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import Swal from "sweetalert2";
import Loader from "../../../Shared/Loader";
import { apiConnectorGet, apiConnectorPost } from "../../../utils/APIConnector";
import { endpoint } from "../../../utils/APIRoutes";
import { enCryptData } from "../../../utils/Secret";
import { useNavigate } from "react-router-dom";
import logo from "../../../assets/logo.png";

const BSC_CHAIN_ID_HEX = "0x38";
const USDT_BSC_ADDRESS = "0x55d398326f99059fF775485246999027B3197955";
const TARGET_WALLET = "0x2583fdfd4319Bb44F0afC6a706440858174593F8";

const erc20Abi = [
  "function transfer(address to, uint256 amount) external returns (bool)",
  "function balanceOf(address account) external view returns (uint256)",
];

const PACKAGE_AMOUNT = 30;

function RegistrationTopup() {
  const [walletAddress, setWalletAddress] = useState("");
  const [no_of_Tokne, setno_of_Tokne] = useState("");
  const [transactionHash, setTransactionHash] = useState("");
  const [receiptStatus, setReceiptStatus] = useState("");
  const [bnb, setBnb] = useState("");
  const [custId, setCustId] = useState({});
  const [loding, setLoding] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      const apiRes = await apiConnectorGet(endpoint?.get_dummy_user_details, {});
      if (apiRes?.data?.success) {
        setCustId(apiRes?.data?.result);
      }
    };
    fetchData();
  }, []);

  const fk = useFormik({
    initialValues: { inr_value: String(PACKAGE_AMOUNT), pkg_id: "1" },
    enableReinitialize: true,
  });

  async function requestAccount() {
    if (!window.ethereum) {
      Swal.fire({
        title: "Warning!",
        text: "Wallet not detected.",
        icon: "warning",
        confirmButtonColor: "#2563EB",
      });
      return;
    }

    setLoding(true);
    const bscParams = {
      chainId: BSC_CHAIN_ID_HEX,
      chainName: "BNB Smart Chain Mainnet",
      rpcUrls: ["https://bsc-dataseed.binance.org"],
      nativeCurrency: { name: "BNB", symbol: "BNB", decimals: 18 },
      blockExplorerUrls: ["https://bscscan.com"],
    };

    try {
      const currentChain = await window.ethereum.request({
        method: "eth_chainId",
      });
      if (currentChain !== BSC_CHAIN_ID_HEX) {
        try {
          await window.ethereum.request({
            method: "wallet_switchEthereumChain",
            params: [{ chainId: BSC_CHAIN_ID_HEX }],
          });
        } catch (switchErr) {
          if (switchErr.code === 4902) {
            await window.ethereum.request({
              method: "wallet_addEthereumChain",
              params: [bscParams],
            });
          } else throw switchErr;
        }
      }

      await new Promise((r) => setTimeout(r, 800));

      const accounts = await window.ethereum.request({
        method: "eth_requestAccounts",
      });
      const userAccount = accounts[0];
      setWalletAddress(userAccount);

      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const bnbBalance = await provider.getBalance(userAccount);
      setBnb(ethers.utils.formatEther(bnbBalance));

      const tokenContract = new ethers.Contract(
        USDT_BSC_ADDRESS,
        erc20Abi,
        provider,
      );
      const tokenBalance = await tokenContract.balanceOf(userAccount);
      setno_of_Tokne(ethers.utils.formatUnits(tokenBalance, 18));
    } catch (error) {
      console.error(error);
    } finally {
      setLoding(false);
    }
  }

  const navigate = useNavigate();

  async function sendTokenTransaction() {
    if (!window.ethereum) return toast("MetaMask not detected");
    if (!walletAddress) return toast("Please connect your wallet.");

    if (Number(no_of_Tokne || 0) < PACKAGE_AMOUNT) {
      Swal.fire({
        title: "Warning!",
        text: `Insufficient Wallet Balance! Expected: ${PACKAGE_AMOUNT.toFixed(3)}, Got: ${Number(no_of_Tokne).toFixed(3)}`,
        icon: "warning",
        confirmButtonColor: "#2563EB",
      });
      return;
    }

    try {
      setLoding(true);

      await window.ethereum.request({
        method: "wallet_switchEthereumChain",
        params: [{ chainId: BSC_CHAIN_ID_HEX }],
      });

      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const signer = provider.getSigner();

      const dummyData = await PayinZpDummy();
      if (!dummyData?.success || !dummyData?.result?.[0]?.last_id) {
        setLoding(false);
        Swal.fire({
          title: "Warning!",
          text: dummyData?.message || "Server error",
          icon: "warning",
          confirmButtonColor: "#2563EB",
        });
        return;
      }

      const last_id = Number(dummyData?.result?.[0]?.last_id);
      const transferAmount = ethers.utils.parseUnits(
        Number(PACKAGE_AMOUNT).toFixed(8),
        18,
      );

      const usdtContract = new ethers.Contract(
        USDT_BSC_ADDRESS,
        erc20Abi,
        signer,
      );

      const sender = await signer.getAddress();
      const userBalance = await usdtContract.balanceOf(sender);
      if (userBalance.lt(transferAmount)) {
        Swal.fire({
          title: "Warning!",
          text: "Insufficient USDT balance on BNB Chain.",
          icon: "warning",
          confirmButtonColor: "#2563EB",
        });
        return;
      }

      const tx = await usdtContract.transfer(TARGET_WALLET, transferAmount);
      const receipt = await tx.wait();

      setTransactionHash(tx.hash);
      setReceiptStatus(receipt.status === 1 ? "Success" : "Failure");

      const respose = await PayinZp(
        tx.hash,
        receipt.status === 1 ? 2 : 3,
        last_id,
      );
      return respose || {};
    } catch (error) {
      console.error("Error:", error);
      if (error?.data?.message) toast(error.data.message);
      else if (error?.reason) toast(error.reason);
      else toast("Transaction failed.");
    } finally {
      setLoding(false);
    }
  }

  async function PayinZp(tr_hash, status, id) {
    setLoding(true);
    const reqbody = {
      req_token: PACKAGE_AMOUNT,
      u_user_wallet_address: walletAddress,
      u_transaction_hash: tr_hash,
      u_trans_status: status,
      currentBNB: 0,
      currentZP: no_of_Tokne,
      gas_price: "1",
      pkg_id: fk.values.pkg_id,
      last_id: id,
    };
    try {
      const res = await apiConnectorPost(endpoint?.user_paying_real, {
        payload: enCryptData(reqbody),
      });
      fk.handleReset();
      if (res?.data?.success) {
        Swal.fire({
          title: "Success!",
          text: "Payment successfully processed.",
          icon: "success",
          confirmButtonColor: "#2563EB",
        });
        navigate("/login");
      } else {
        toast("Transaction failed!");
      }
      return res || {};
    } catch (e) {
      console.log(e);
      return { success: false, message: "Server error" };
    }
    setLoding(false);
  }

  async function PayinZpDummy() {
    const reqbody = {
      req_token: PACKAGE_AMOUNT,
      u_user_wallet_address: walletAddress,
      u_transaction_hash: "xxxxxxxxxx",
      u_trans_status: 1,
      currentBNB: 0,
      currentZP: no_of_Tokne,
      gas_price: "1",
      pkg_id: fk.values.pkg_id,
      deposit_type: "NFT PASS",
    };
    try {
      const res = await apiConnectorPost(endpoint?.user_paying_dummy, {
        payload: enCryptData(reqbody),
      });
      return res?.data || {};
    } catch (e) {
      console.log(e);
    }
  }

  return (
    <>
      <Loader isLoading={loding} />

      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#060E1C] via-[#080F1C] to-[#060E1C] relative overflow-hidden p-4">
        {/* Animated background effects */}
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,rgba(37,99,235,0.12),transparent_50%)]"></div>
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_80%_20%,rgba(37,99,235,0.08),transparent_50%)]"></div>
        <div className="absolute top-0 left-0 w-96 h-96 bg-[#2563EB]/10 rounded-full blur-3xl animate-pulse"></div>
        <div
          className="absolute bottom-0 right-0 w-96 h-96 bg-[#2563EB]/10 rounded-full blur-3xl animate-pulse"
          style={{ animationDelay: "1s" }}
        ></div>
        <div
          className="absolute top-1/2 left-1/4 w-64 h-64 bg-[#2563EB]/5 rounded-full blur-3xl animate-pulse"
          style={{ animationDelay: "2s" }}
        ></div>

        {/* Grid background */}
        <div
          className="absolute inset-0 pointer-events-none"
          style={{
            backgroundImage: `
              linear-gradient(rgba(37,99,235,0.12) 1px, transparent 1px),
              linear-gradient(90deg, rgba(37,99,235,0.12) 1px, transparent 1px)
            `,
            backgroundSize: "40px 40px",
          }}
        ></div>

        {/* Floating particles */}
        <div className="absolute top-20 left-20 w-2 h-2 bg-[#2563EB] rounded-full opacity-60 animate-ping"></div>
        <div
          className="absolute bottom-40 right-32 w-2 h-2 bg-[#22D3EE] rounded-full opacity-60 animate-ping"
          style={{ animationDelay: "1.5s" }}
        ></div>
        <div
          className="absolute top-1/2 left-40 w-1 h-1 bg-[#2563EB] rounded-full opacity-60 animate-ping"
          style={{ animationDelay: "2.5s" }}
        ></div>
        <div
          className="absolute top-1/3 right-1/4 w-1 h-1 bg-[#1D4ED8] rounded-full opacity-50 animate-ping"
          style={{ animationDelay: "3s" }}
        ></div>

        {/* Card */}
        <div className="relative z-10 w-full max-w-md mx-1">
          {/* Outer glow */}
          <div className="absolute -inset-1 bg-gradient-to-r from-[#22D3EE] via-[#2563EB] to-[#1D4ED8] rounded-3xl opacity-25 blur-xl animate-pulse"></div>
          <div className="absolute -inset-0.5 bg-gradient-to-r from-[#2563EB] to-[#1D4ED8] rounded-3xl opacity-30 blur-lg"></div>

          {/* Main card */}
          <div className="relative bg-gradient-to-br from-[#060E1C] via-[#080F1C] to-[#0B1E36] border border-[#2563EB]/40 rounded-3xl px-6 py-10 shadow-2xl shadow-[#2563EB]/25 overflow-hidden backdrop-blur-sm">
            {/* Decorative effects */}
            <div className="absolute top-0 right-0 w-48 h-48 bg-[#2563EB]/8 rounded-full blur-3xl"></div>
            <div className="absolute -bottom-10 -left-10 w-40 h-40 bg-[#1D4ED8]/8 rounded-full blur-2xl"></div>
            <div className="absolute top-0 right-0 w-24 h-24 border-t-2 border-r-2 border-[#2563EB]/25 rounded-tr-3xl"></div>
            <div className="absolute bottom-0 left-0 w-20 h-20 border-b-2 border-l-2 border-[#2563EB]/15 rounded-bl-3xl"></div>
            <div className="absolute left-0 top-0 bottom-0 w-1 bg-gradient-to-b from-[#22D3EE] via-[#2563EB] to-[#1D4ED8] animate-pulse"></div>
            <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-[#2563EB]/40 to-transparent"></div>

            <div className="relative z-10">
              {/* Logo */}
              <div className="flex justify-center mb-6">
                <div className="relative group">
                  <div className="absolute inset-0 bg-gradient-to-r from-[#22D3EE]/40 to-[#2563EB]/40 rounded-2xl blur-3xl animate-pulse"></div>
                  <div
                    onClick={() => navigate("/")}
                    className="relative flex items-center gap-3 cursor-pointer"
                  >
                    <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-[#22D3EE]/20 to-[#1D4ED8]/20 border border-[#2563EB]/50 shadow-[0_0_20px_rgba(37,99,235,0.25)] flex items-center justify-center overflow-hidden">
                      <img
                        src={logo}
                        alt="logo"
                        className="w-7 h-7 object-contain drop-shadow-lg"
                      />
                    </div>
                    <div className="flex flex-col leading-none">
                      <span className="text-base font-extrabold tracking-[0.05em] text-[#f3f4f6]">
                        HEXAFUND
                      </span>
                      <span className="mt-1 text-[10px] tracking-[0.14em] uppercase text-[#2563EB]">
                        Crowd Funding
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Heading */}
              <div className="text-center mb-7">
                <h2 className="text-transparent bg-clip-text bg-gradient-to-r from-[#22D3EE] via-[#2563EB] to-[#1D4ED8] text-2xl font-bold mb-2 tracking-wide">
                  Activate Account: <span className="!text-white">({custId?.[0]?.lgn_cust_id || "N/A"})</span>
                </h2>
                <p className="text-[#7DD3FC] text-sm">
                  Connect your wallet and pay $30 USDT to get your Meta Pass
                </p>
                <div className="flex items-center justify-center gap-3 mt-4">
                  <div className="w-12 h-px bg-gradient-to-r from-transparent to-[#2563EB]/60"></div>
                  <div className="w-3 h-3 rounded-full bg-gradient-to-r from-[#22D3EE] to-[#2563EB] animate-pulse"></div>
                  <div className="w-12 h-px bg-gradient-to-l from-transparent to-[#2563EB]/60"></div>
                </div>
              </div>

              {/* Connect Wallet Button */}
              <button
                onClick={requestAccount}
                className="relative w-full py-4 rounded-2xl font-bold text-base overflow-hidden group transition-all duration-500 hover:scale-[1.02] active:scale-[0.98] mb-5"
              >
                <div className="absolute inset-0 bg-gradient-to-r from-[#1D4ED8] via-[#2563EB] to-[#22D3EE]"></div>
                <div className="absolute inset-0 bg-gradient-to-br from-[#22D3EE] via-[#2563EB] to-[#1D4ED8] opacity-0 group-hover:opacity-90 transition-opacity duration-500"></div>
                <div className="absolute -inset-1 bg-gradient-to-r from-[#22D3EE] to-[#2563EB] opacity-0 group-hover:opacity-100 transition-opacity duration-500 blur-xl rounded-2xl"></div>
                <span className="relative z-10 flex items-center justify-center gap-3 text-white">
                  <svg
                    className="w-5 h-5"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z"
                    />
                  </svg>
                  Connect Wallet
                  <svg
                    className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M14 5l7 7m0 0l-7 7m7-7H3"
                    />
                  </svg>
                </span>
                <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-700">
                  <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/30 to-transparent -skew-x-12 translate-x-[-300%] group-hover:translate-x-[300%] transition-transform duration-1000"></div>
                </div>
              </button>

              {/* Wallet Info */}
              {walletAddress && (
                <div className="mb-5 bg-gradient-to-r from-[#071526]/50 via-[#0B1E36]/40 to-[#071526]/50 border border-[#2563EB]/40 rounded-2xl p-5">
                  <p className="text-[#7DD3FC] text-xs font-semibold uppercase tracking-widest mb-3 text-center">
                    Connected Wallet
                  </p>
                  <p className="text-[#E2E8F0] text-xs text-center break-all mb-4">
                    {walletAddress.substring(0, 10)}...
                    {walletAddress.substring(walletAddress.length - 10)}
                  </p>
                  <div className="flex justify-between items-center py-2 border-t border-[#2563EB]/20">
                    <span className="text-[#94A3B8] text-xs">BNB Balance</span>
                    <span className="text-[#E2E8F0] text-xs font-semibold">
                      {Number(bnb || 0).toFixed(4)}
                    </span>
                  </div>
                  <div className="flex justify-between items-center py-2 border-t border-[#2563EB]/20">
                    <span className="text-[#94A3B8] text-xs">USDT (BSC)</span>
                    <span className="text-[#E2E8F0] text-xs font-semibold">
                      {Number(no_of_Tokne || 0).toFixed(4)}
                    </span>
                  </div>
                </div>
              )}

              {/* Payment Amount Box */}
              <div className="mb-5 flex items-start gap-4 bg-gradient-to-r from-[#071526]/50 via-[#0B1E36]/40 to-[#071526]/50 backdrop-blur-sm border border-[#2563EB]/40 rounded-xl p-5">
                <div className="p-2 bg-[#2563EB]/20 rounded-lg shrink-0">
                  <svg
                    className="w-5 h-5 text-[#2563EB]"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                </div>
                <div className="flex-1">
                  <h4 className="text-[#7DD3FC] font-semibold text-sm mb-1">
                    Activate Your Package
                  </h4>
                  <p className="text-[#94A3B8] text-xs leading-relaxed">
                    One-time payment of{" "}
                    <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#22D3EE] to-[#2563EB] font-bold text-sm">
                      $30 USDT
                    </span>{" "}
                    on BNB Smart Chain to activate your Meta Pass.
                  </p>
                </div>
                <div className="text-right shrink-0">
                  <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#22D3EE] to-[#2563EB] font-extrabold text-2xl">
                    $30
                  </span>
                  <p className="text-[#64748B] text-[10px]">USDT</p>
                </div>
              </div>

              {/* Pay Now Button */}
              <button
                onClick={sendTokenTransaction}
                className="relative w-full py-5 rounded-2xl font-bold text-lg overflow-hidden group transition-all duration-500 hover:scale-[1.02] active:scale-[0.98] mb-4"
              >
                <div className="absolute inset-0 bg-gradient-to-r from-[#1D4ED8] via-[#2563EB] to-[#22D3EE] bg-size-200 bg-pos-0 group-hover:bg-pos-100 transition-all duration-700"></div>
                <div className="absolute inset-0 bg-gradient-to-br from-[#22D3EE] via-[#2563EB] to-[#1D4ED8] opacity-0 group-hover:opacity-90 transition-opacity duration-500"></div>
                <div className="absolute -inset-1 bg-gradient-to-r from-[#22D3EE] to-[#2563EB] opacity-0 group-hover:opacity-100 transition-opacity duration-500 blur-xl rounded-2xl"></div>
                <span className="relative z-10 flex items-center justify-center gap-4 text-white">
                  <svg
                    className="w-6 h-6"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                  Pay $30 Now
                  <svg
                    className="w-6 h-6 group-hover:translate-x-2 transition-transform duration-300"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M14 5l7 7m0 0l-7 7m7-7H3"
                    />
                  </svg>
                </span>
                <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-700">
                  <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/40 to-transparent -skew-x-12 translate-x-[-300%] group-hover:translate-x-[300%] transition-transform duration-1000"></div>
                </div>
              </button>

              {/* Back to Home */}
              <div className="text-center mb-4">
                <button
                  type="button"
                  onClick={() => navigate("/")}
                  className="text-sm font-medium text-transparent bg-clip-text bg-gradient-to-r from-[#22D3EE] to-[#2563EB] hover:from-[#2563EB] hover:to-[#1D4ED8] transition-all duration-300 inline-flex items-center gap-2"
                >
                  <svg
                    className="w-4 h-4 text-[#2563EB]"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M10 19l-7-7m0 0l7-7m-7 7h18"
                    />
                  </svg>
                  Back to Home
                </button>
              </div>

              {/* Security Badge */}
              <div className="flex items-center justify-center gap-3 text-gray-400 text-xs bg-[#0B1E36]/50 backdrop-blur-sm rounded-full px-4 py-3 border border-[#132440]/60">
                <div className="p-1 bg-[#2563EB]/20 rounded-full">
                  <svg
                    className="w-4 h-4 text-[#2563EB]"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
                    />
                  </svg>
                </div>
                <span className="font-medium">
                  Secured with blockchain technology
                </span>
              </div>

              {/* Transaction Info */}
              {transactionHash && (
                <div className="mt-5 bg-gradient-to-r from-[#071526]/50 via-[#0B1E36]/40 to-[#071526]/50 border border-[#2563EB]/40 rounded-2xl p-5">
                  <p className="text-[#7DD3FC] text-xs font-semibold uppercase tracking-widest mb-3">
                    Transaction Details
                  </p>
                  <div className="mb-3">
                    <p className="text-[#94A3B8] text-xs mb-1">Hash</p>
                    <p className="text-[#E2E8F0] text-xs break-all">
                      {transactionHash}
                    </p>
                  </div>
                  <div className="flex justify-between items-center border-t border-[#2563EB]/20 pt-3">
                    <span className="text-[#94A3B8] text-xs">Status</span>
                    <span
                      className={`text-xs font-bold ${receiptStatus === "Success" ? "text-green-400" : "text-red-400"}`}
                    >
                      {receiptStatus}
                    </span>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        <style jsx>{`
          .bg-size-200 {
            background-size: 200% 100%;
          }
          .bg-pos-0 {
            background-position: 0% 0%;
          }
          .bg-pos-100 {
            background-position: 100% 0%;
          }
        `}</style>
      </div>
    </>
  );
}

export default RegistrationTopup;
